module.exports = __webpack_public_path__ + "static/media/za.9ed44aea.svg";